import { fetchResource } from "../helpers/network";

import {
  setErrorNotification,
  setSuccessNotification
} from "../actions/notifications";

export const REQUEST_ACCOUNTS = "REQUEST_ACCOUNTS";
export const RECEIVE_ACCOUNTS = "RECEIVE_ACCOUNTS";
export const REQUEST_ACCOUNT = "REQUEST_ACCOUNT";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT";

export const requestAccounts = () => ({
  type: REQUEST_ACCOUNTS
});

export const requestAccount = () => ({
  type: REQUEST_ACCOUNT
});

export const receiveAccounts = json => ({
  /* coerce to array */
  type: RECEIVE_ACCOUNTS,
  accounts: Array.isArray(json.data) ? json.data : json.data ? [json.data] : []
});

export function fetchAccounts(params) {
  const paramsWithPath = Object.assign({}, params, { path: "/accounts" });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestAccounts,
        receiveAccounts,
        setErrorNotification
      )
    );
  };
}

export function fetchAccount(id, params) {
  const paramsWithPath = Object.assign({}, params, { path: `/accounts/${id}` });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestAccount,
        receiveAccounts,
        setErrorNotification
      )
    );
  };
}

export function patchAccount(id, params) {
  const paramsWithPath = Object.assign({}, params, {
    path: `/accounts/${id}`,
    method: "PATCH"
  });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        null,
        json => {
          dispatch(
            setSuccessNotification(`Updated account ${json.data.name}`, null)
          );
          return receiveAccounts(json);
        },
        setErrorNotification
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/accounts.js